import _BaseController from 'Controllers/Web/_BaseController';
import Datalayer from 'Controllers/Web/Datalayer';
import HomePageControllerVue from 'Vue/Web/HomePageController.vue';

global.Controller = new (class extends _BaseController {
    IndexControllerVue?: Vue;

    ready() {
        super.ready();

        this.IndexControllerVue = new Vue(HomePageControllerVue);
        // datalayer
        Datalayer.push(Json.datalayer);

        // search
        const searchHeight = $('#first')
            .height();
        $('.search-pic')
            .height(searchHeight);

        // 數字
        const height = $('#second')
            .outerHeight(true) + $('#first')
            .outerHeight(true);

        $('.icon-number')
            .each((index, element) => {
                const startValue = 1; // 從1開始
                const endValue = $(element)
                    .text(); // 目標值
                const duration = 5000; // 動畫持續時間
                const interval = 10; // 重置倒數的時間間隔，這裡設為每10ms

                function startCounting() {
                    $(element)
                        .prop('Counter', startValue)
                        .animate({ Counter: endValue }, {
                            duration,
                            easing: 'swing',
                            step: (now) => {
                                $(element)
                                    .text(Math.ceil(now));
                            },
                            complete() {
                                // 動畫完成後，重新開始倒數
                                setTimeout(startCounting, interval);
                            },
                        });
                }

                // 開始倒數
                startCounting();
            });
    }
})();
